// Response codes
export const SUCCESS_CODE = "V3OK"; // Success code
export const FAILED_CODE = "V3ER001"; // Error code for validations
export const FAILED_BUSSINESS_CODE = "V3ER002"; // Error code for business logic.

export const FAILED_CODE_701 = "V3ER701";
export const FAILED_CODE_702 = "V3ER702";